






























import Vue from 'vue';
import Heading from './components/Heading.vue';
import Inputs from './components/Inputs.vue';
import OrderDetails from './components/OrderDetails.vue';
import OrdersList from './components/OrdersList.vue';
import Timer from './components/Timer.vue';
import Menu from './components/Menu.vue';
import { Order } from './models';
import {createOrder} from './utils';

export default Vue.extend({
  name: 'app',
  components: {
    'one-heading': Heading,
    'one-inputs': Inputs,
    'one-order-details': OrderDetails,
    'one-orders-list': OrdersList,
    'one-timer': Timer,
    'one-menu': Menu
  },
  created() {
    this.$store.commit('setShowMenu', true);
  },
  computed: {
    showMenu(): boolean {
      return this.$store.state.showMenu;
    }
  }
});
